export default function sortBy() {
  const el = document.querySelector('.js-c-sortby');
  if (!el) return;

  el.querySelector('.c-sortby__trigger')?.addEventListener('click', () => {
    el.classList.toggle('is-open');
  });

  const mql = window.matchMedia('(min-width: 781px)');
  mql.addEventListener('change', handle);
  handle(mql);

  function handle(mql) {
    if (mql.matches) el.classList.remove('is-open');
  }
}
